import { ApolloProvider } from '@apollo/client';
import useCreateApolloClient from '@src/app/global/providers/ApolloProvider/useCreateApolloClient';
import type { ReactNode } from 'react';

interface ApolloWrapperProps {
  children: ReactNode;
}

export const ApolloWrapper = ({ children }: ApolloWrapperProps) => {
  const client = useCreateApolloClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
